import { useEffect, useRef, useState } from 'react';
import { useAuthContext } from '../../hooks/AuthContext';
import { useControllerFlowStepsContext } from '../../hooks/ControllerFlowStepsContext';
import LoadingFullScreen, {
  LoadingFullScreenHandles
} from '../LoadingFullScreen/LoadingFullScreen';
import BackToAppFullScreen, {
  BackToAppFullScreenHandles
} from '../BackToAppFullScreen/BackToAppFullScreen';

import './Container.scss';
import LogoText from '../LogoText/LogoText';
import CookiesBanner from '../CookiesBanner';
import LandingView from './LandingView';

interface ContainerProps {
  className?: string;
  children: React.ReactNode;
}

export default function Container(props: ContainerProps) {
  const { user, openGoBackToApp } = useAuthContext();
  const { loadingFullScreen } = useControllerFlowStepsContext();
  const refLoadingFullScreen = useRef<LoadingFullScreenHandles>(null);
  const refGoBackToAppFullScreen = useRef<BackToAppFullScreenHandles>(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 901);
  const [header, setHeader] = useState('');

  const [showLandingPage, setShowLandingPage] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 901);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (loadingFullScreen) {
      refLoadingFullScreen?.current?.openLoadingFullScreen();
    } else {
      refLoadingFullScreen?.current?.closeLoadingFullScreen();
    }
  }, [loadingFullScreen]);

  useEffect(() => {
    if (openGoBackToApp) {
      refGoBackToAppFullScreen?.current?.openBackToAppFullScreen();
    } else {
      refGoBackToAppFullScreen?.current?.closeBackToAppFullScreen();
    }
  }, [openGoBackToApp]);

  return (
    <>
      <div
        className={`container flex ${props.className || ''} ${
          user ? 'container__opened' : ''
        }`}
      >
        {!isMobile && (
          <div className="container__left">
            <div className="container__header">
              <LogoText />
              <h4>
                {header ||
                  'Uma forma simples e segura de se conectar ao mundo do SBT.'}
              </h4>
            </div>

            {showLandingPage && (
              <LandingView setHeader={(value) => setHeader(value)} />
            )}

            <div className="container__footer">
              {!showLandingPage && (
                <p
                  className="account-detail"
                  onClick={() => setShowLandingPage(true)}
                >
                  Pra que ter uma Conta SBT?
                </p>
              )}
              <CookiesBanner />
            </div>
          </div>
        )}
        <div className="container__right">{props.children}</div>
      </div>
      <LoadingFullScreen ref={refLoadingFullScreen} />
      <BackToAppFullScreen ref={refGoBackToAppFullScreen} />
    </>
  );
}
